export const appVersion = {
  version: 'v26.05.28',
  deploy: '-dev.21',
};
